<script setup lang="ts">
import FormPerguntaResposta from '../components/form-pergunta-resposta.vue'
import { usePerguntaRespostaStore } from '../store/usePerguntaRespostaStore'

definePage({
  meta: {
    navActiveLink: 'admin-perguntaresposta',
    action: 'create',
    subject: 'perguntaresposta',
  },
})

const { resetForm } = usePerguntaRespostaStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormPerguntaResposta />
</template>
